export default "__VITE_ASSET__Ba7yJLjj__"